import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'

import type { AgreementsAlertBody } from '../alertHover.types'
import { agreementsStyles } from './Agreements.styles'

const AgreementsBody: React.FC<{ body: AgreementsAlertBody }> = ({ body }) => {
  const { t } = useTranslation('alerts')

  if (!body) {
    return null
  }

  return (
    <Box sx={agreementsStyles.root}>
      <Box sx={agreementsStyles.row}>
        <Typography sx={agreementsStyles.label}>
          {t('agreements.pending', { count: body.count ?? 0 })}
        </Typography>
      </Box>
    </Box>
  )
}

export default AgreementsBody
